<template>
  <div v-if="localShow" class="modal-overlay" @click="closeModal">
    <div class="modal-dialog" @click.stop>
      <BaseDialog
        :title="'Annotation Set'"
        :footerButtons="['Save']"
        @cancel="closeModal"
        @footer-click="handleFooterClick"
      >
        <div class="settings__control-group">
          <label>Name</label>
          <input
            ref="annSetName"
            v-model="name"
            class="select"
            type="text"
          >
        </div>
        <div class="settings__control-group">
          <label>Description</label>
          <textarea
            v-model="description"
            rows="4"
            cols="50"
          />
        </div>
      </BaseDialog>
    </div>
  </div>
</template>

<script>
import DatastoreConnect from '@/assets/js/DatastoreFunctions/datastore-interface';
import BaseDialog from '@/components/DilaogTemplate/BaseDialog.vue';

export default {
  name: 'UpdateAnnotationSetModal',
  components: {
    BaseDialog,
  },
  props: {
    annotationSet: {
      type: Object,
      default: null,
    },
  },
  emits: ['annotation-set-updated'],
  data() {
    return {
      name: '',
      description: '',
      localShow: false,
    };
  },
  computed: {
    user() {
      return this.$store.state.user.user;
    },
  },
  created() {
    this.dataConnect = new DatastoreConnect(this.$store.state.enterpriseServerUrl);
  },
  methods: {
    showModal() {
      this.localShow = true;
      if (this.annotationSet) {
        this.name = this.annotationSet.name;
        this.description = this.annotationSet.description;
      }
      this.$nextTick(() => {
        this.$refs.annSetName.focus();
      });
    },
    closeModal() {
      this.name = '';
      this.description = '';
      this.localShow = false;
    },
    handleFooterClick(buttonLabel) {
      if (String(buttonLabel || '').toLowerCase() === 'save') {
        this.updateAnnotationSet();
      }
    },
    async updateAnnotationSet() {
      if (!this.name) {
        console.error('Missing name');
        return;
      }
      const resp = await this.dataConnect.updateAnnotationSet({
        annotation_set_id: this.annotationSet.id,
        name: this.name,
        description: this.description,
      })
        .catch((error) => {
          // TODO: handle error
          console.log(error);
        });

      this.name = '';
      this.description = '';
      this.localShow = false;
      this.$emit('annotation-set-updated', resp.result);
    },
  },
};

</script>

<style lang="scss" scoped>

.modal-overlay {
  position: fixed;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 16px;
  background: rgba(0, 0, 0, 0.45);
  z-index: 2000;
}

.modal-dialog {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>

